/** @jsx jsx */
import { Fragment, useContext } from 'react'
import { jsx, css } from '@emotion/core'
import { Badge } from '@livechat/design-system'
import useMedia from 'use-media'

import { Context } from '../../context'
import MarkdownRenderer from '../MarkdownRenderer'
import Delete from './Delete'

const Response = ({ surveyId, structure }) => {
  const isNarrow = useMedia({ maxWidth: 1125 })
  const { surveyResponse } = useContext(Context)

  return (
    <Fragment>
      {surveyResponse.map((answer, answerIndex) => {
        return (
          <div
            className="visitor-response"
            key={`${answer.id}-detailed-response-${answerIndex}`}
          >
            <div>
              <Badge>{answerIndex + 1}</Badge>
              <span className="divider" />
            </div>
            {structure.map((field, fieldIndex) => {
              return (
                <div
                  key={`${surveyId}-detailed-field-${answerIndex}-${fieldIndex}`}
                  className="field"
                >
                  <div className="question">
                    <MarkdownRenderer>{field.question}</MarkdownRenderer>
                  </div>
                  {field.type === 'TEXT_ANSWER' && (
                    <div className="answer">
                      {answer.response[fieldIndex] || '-'}
                    </div>
                  )}

                  {field.type === 'SINGLE_CHOICE' && (
                    <div className="answer">
                      {field.answers[answer.response[fieldIndex]] || '-'}
                    </div>
                  )}

                  {field.type === 'MULTI_CHOICE' && (
                    <div className="answer">
                      {answer.response[fieldIndex].length > 0
                        ? answer.response[fieldIndex].map(
                            (visitorAnswerIndex) => {
                              return (
                                <div
                                  key={`${surveyId}-detailed-multi-choice-${answerIndex}-${fieldIndex}-${visitorAnswerIndex}`}
                                >
                                  {field.answers[visitorAnswerIndex] || '-'}
                                </div>
                              )
                            }
                          )
                        : '-'}
                    </div>
                  )}
                  {field.type === 'SCORE' && (
                    <div className="answer">
                      {answer.response[fieldIndex] || '-'}{' '}
                      <span
                        css={css`
                          font-weight: 300;
                        `}
                      >
                        / {field.score?.range?.max}
                      </span>
                    </div>
                  )}
                </div>
              )
            })}
            <div
              css={css`
                width: 100%;
                display: flex;
                justify-content: flex-end;
              `}
            >
              <Delete responseId={answer.id} surveyId={surveyId} />
            </div>
          </div>
        )
      })}
      {isNarrow ? (
        <div className="empty-box" />
      ) : (
        <Fragment>
          <div className="empty-box" />
          <div className="empty-box" />
        </Fragment>
      )}
      <div className="visitor-response-empty"></div>
      <div className="visitor-response-empty"></div>
    </Fragment>
  )
}

export default Response
